<div class="date-filter" *ngIf="currentDate">
    <div class="date-filter__date-wrapper">
        <div class="date-filter__date">
            <div class="bz-input-icon bz-space--inline-s" [ngClass]="{'disabled-input': isDisabled}">
                <input #dpDateInput class="bz-input bz-input-icon__input bz-space--inline-s" autocomplete="off"
                    placeholder="{{'GLOBAL.FROM' | translate}}" mask="00/00/0000 00:00:00" id="date-current"
                    #dpDate="bsDatepicker" [(ngModel)]="currentDateToShow"
                    (click)="setDatePickerActive('currentDate', 0)" (ngModelChange)="onDateMinChange($event)"
                    [bsConfig]="{ container: 'body', adaptivePosition: true, placement: 'top', maxDate: dateMax, showWeekNumbers: false, dateInputFormat: 'DD/MM/YYYY HH:mm:ss' }"
                    [disabled]="isDisabled" bsDatepicker>
                <svg class="bz-icon" height="32px" width="32px"
                    (click)="setDatePickerActive('currentDate', 0); dpDate.show()" [ngClass]="{'disabled': isDisabled}">
                    <use href="#icon-calendar2"></use>
                </svg>
                <svg class="bz-icon bz-icon-mr time-picker-icon" height="32px" width="32px"
                    (click)="setDatePickerActive('currentDate', 1)" [ngClass]="{'disabled': isDisabled}">
                    <use href="#icon-timer"></use>
                </svg>
                <bz-time-picker 
                    class="bz-timer-positon"
                    *ngIf="timePickers.currentDate"
                    [(dateInput)]="currentDateToShow"
                    [isVisible]="timePickers.currentDate"
                    (timeChange)="updateDate($event)"
                    [showSeconds]="true"
                    [showIcon]="false">
                </bz-time-picker>
            </div>
        </div>
    </div>
</div>